import styled from 'styled-components'

const Title = styled.span`
  display: flex;
  align-items: center;

  > span {
    display: inline-block;
    margin-left: 10px;
    color: ${(p) => p.theme.uiKit.colors.theme.negative.main};
  }
`

const Content = styled.ol`
  padding: 0 50px;
  line-height: 2;
  color: ${(p) => p.theme.uiKit.colors.theme.negative.main};
`

export const s = { Title, Content }
